import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

const originalPush: any = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err);
};

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/CanNotAccess",
    name: "CanNotAccess",
    component: () => import("@/views/CanNotAccess.vue"),
    meta: { title: "PEAK Payroll" },
  },
  {
    path: "/CanNotAccessMerchant",
    name: "canNotAccessMerchant",
    component: () => import("@/views/CanNotAccessMerchant.vue"),
    meta: { title: "PEAK Payroll" },
  },
  {
    path: "/SessionExpire",
    name: "sessionExpire",
    component: () => import("@/views/SessionExpire.vue"),
    meta: { title: "PEAK Payroll" },
  },
  { path: "*", redirect: "/404", meta: { title: "PEAK Payroll" } },
  {
    path: "/404",
    name: "pageNotFound",
    component: () => import("@/views/PageNotFound.vue"),
    meta: { title: "PEAK Payroll" },
  },
  {
    path: "/",
    name: "login",
    component: () => import("@/views/login/LoginPage.vue"),
    meta: { title: "PEAK Payroll" },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/login/LogOut.vue"),
    meta: { title: "PEAK Payroll" },
  },
  {
    path: "/selectList",
    name: "selectList",
    component: () => import("@/views/selectCompany/SelectList.vue"),
    meta: { title: "select_list" },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/Home.vue"),
    meta: { title: "Menu_Home", breadcrumb: [{ name: "Menu_Home" }] },
  },
  {
    path: "/revenue",
    name: "revenue",
    component: () => import("@/views/revenue/Revenue.vue"),
    meta: { title: "Menu_Revenue_Deduct", breadcrumb: [{ name: "Menu_Revenue_Deduct" }] },
  },
  {
    path: "/department",
    name: "department",
    component: () => import("@/views/department/Department.vue"),
    meta: { title: "Menu_Department", breadcrumb: [{ name: "Menu_Department", linkName: "department" }] },
    children: [
      {
        path: "departmentDetail",
        name: "departmentDetail",
        component: () => import("@/views/department/DepartmentDetail.vue"),
        meta: { breadcrumb: [{ name: "Menu_Department", linkName: "department" }] },
      },
    ],
  },
  {
    path: "/employee",
    name: "employee",
    component: () => import("@/views/employee/Employee.vue"),
    meta: { title: "Menu_Employee", breadcrumb: [{ name: "Menu_Employee" }] },
    children: [
      {
        path: "employeeDetail",
        name: "employeeDetail",
        component: () => import("@/views/employee/employeeDetail/EmployeeDetail.vue"),
        meta: { breadcrumb: [{ name: "Menu_Employee", linkName: "employee" }] },
      },
      {
        path: "importEmployeePreview",
        name: "importEmployeePreview",
        component: () => import("@/views/employee/importEmployeePreview/ImportEmployeePreview.vue"),
        meta: {
          title: "Import_Employee_Preview",
          breadcrumb: [{ name: "Menu_Employee", linkName: "employee" }, { name: "Import_Employee_Preview" }],
        },
      },
    ],
  },

  {
    path: "/setting",
    name: "setting",
    component: () => import("@/views/setting/Setting.vue"),
    meta: { title: "Menu_Setting", breadcrumb: [{ name: "Menu_Setting" }] },
  },
  {
    path: "/salary",
    name: "salary",
    component: () => import("@/views/salary/Salary.vue"),
    meta: { title: "Menu_Salary", breadcrumb: [{ name: "Menu_Salary" }] },
    children: [
      {
        path: "salaryCreate",
        name: "salaryCreate",
        component: () => import("@/views/salary/salaryCreate/SalaryCreate.vue"),
        meta: {
          title: "Create_salary_Pay_Run",
          breadcrumb: [{ name: "Menu_Salary", linkName: "salary" }, { name: "Create_salary_Pay_Run" }],
        },
      },
      {
        path: "salaryDetail",
        name: "salaryDetail",
        component: () => import("@/views/salary/salaryDetail/SalaryDetail.vue"),
        meta: { breadcrumb: [{ name: "Menu_Salary", linkName: "salary" }] },
      },
      {
        path: "salaryEdit",
        name: "salaryEdit",
        component: () => import("@/views/salary/salaryEdit/SalaryEdit.vue"),
        meta: {
          title: "Edit_salary_Pay_Run",
          breadcrumb: [{ name: "Menu_Salary", linkName: "salary" }, { name: "Edit_salary_Pay_Run" }],
        },
      },
      {
        path: "salarySummary",
        name: "salarySummary",
        component: () => import("@/views/salary/salarySummary/SalarySummaryTable.vue"),
        meta: {
          title: "Salary_Summary",
          breadcrumb: [{ name: "Salary_Summary", linkName: "salarySummary" }],
        },
      },
      {
        path: "salarySummaryDetail",
        name: "salarySummaryDetail",
        component: () => import("@/views/salary/salarySummary/salarySummaryDetail/SalarySummaryDetail.vue"),
        meta: { breadcrumb: [{ name: "Salary_Summary", linkName: "salarySummary" }] },
      },
      {
        path: "pnd1K",
        name: "pnd1K",
        component: () => import("@/views/salary/salarySummary/salarySummaryDetail/Pnd1KPaper.vue"),
      },
      {
        path: "pnd1KItem",
        name: "pnd1KItem",
        component: () => import("@/views/salary/salarySummary/salarySummaryDetail/Pnd1KItem.vue"),
      },
      {
        path: "withholdingTax",
        name: "withholdingTax",
        component: () => import("@/views/salary/salarySummary/salarySummaryDetail/WhtCertificatePaper.vue"),
      },
    ],
  },
  {
    path: "/statement",
    name: "statement",
    component: () => import("@/views/statement/Statement.vue"),
    meta: { title: "statement", breadcrumb: [{ name: "statement" }] },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
